import { Box, BoxProps } from "@chakra-ui/react";

/**
 * An item in a DetailSidebar. This is the most generic item in a DetailSidebar that provides little more than proper spacing
 */
export const DetailItem = (props: BoxProps) => {
  return <Box my={4} _first={{ mt: 0 }} {...props} />;
};
